import { render, staticRenderFns } from "./DashboardAccessLoader.vue?vue&type=template&id=b4b05f84"
import script from "./DashboardAccessLoader.vue?vue&type=script&lang=js"
export * from "./DashboardAccessLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports